module.exports = __webpack_public_path__ + "static/img/Logo.e235090.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login/Logo.png
// module id = 373
// module chunks = 1